import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const rootSx: SxProps<Theme> = {
	width: '100%',
};

export const productCardSx: SxProps<Theme> = {
	width: 'auto',
};

export const titleContainerSx: SxProps<Theme> = {
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	marginBottom: '15px',
};

export const titleSX: SxProps<Theme> = {
	fontFamily: ['Open Sans', 'Helvetica Neue', 'Arial', 'sans-serif'].join(','),
	fontWeight: OpenSansFontWeights.light,
	fontSize: { xs: '21px', sm: '27px' },
	lineHeight: 1.235,
	alignItems: 'baseline',
	whiteSpace: 'break-spaces',
	width: 'fit-content',
};
